import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loadingStatus?: boolean;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loadingStatus,
  message = "Bu işlemi gerçekleştirmek istediğinize emin misiniz?",
  confirmText = "Evet",
  cancelText = "Hayır",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "400px",
          padding: "16px",
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold" }}>
        {"Onay"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: "14px", color: "black" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loadingStatus}
          sx={{
            borderColor: "var(--color-primary)", color: "var(--color-primary)", borderRadius: "6px", textTransform: "none", width: "6rem",
            "&:hover": { borderColor: "var(--color-primary-dark)", backgroundColor: "var(--color-primary-alpha-05)" },
          }}
        >
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={loadingStatus}
          sx={{
            backgroundColor: "var(--color-primary)", borderRadius: "6px", textTransform: "none", width: "6rem",
            "&:hover": { backgroundColor: "var(--color-primary-dark)" },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
